import { SvgIcon, SvgIconProps } from '@mui/material'

export function CalenderIcon(props: SvgIconProps) {
  return (
    <SvgIcon role="img" viewBox="0 0 16 16" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.00004 1.83333C1.90799 1.83333 1.83337 1.90795 1.83337 1.99999V14C1.83337 14.092 1.90799 14.1667 2.00004 14.1667H14C14.0921 14.1667 14.1667 14.092 14.1667 14V1.99999C14.1667 1.90795 14.0921 1.83333 14 1.83333H2.00004ZM0.833374 1.99999C0.833374 1.35566 1.35571 0.833328 2.00004 0.833328H14C14.6444 0.833328 15.1667 1.35566 15.1667 1.99999V14C15.1667 14.6443 14.6444 15.1667 14 15.1667H2.00004C1.35571 15.1667 0.833374 14.6443 0.833374 14V1.99999Z"
        fill={props?.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.833374 4.66667C0.833374 4.39053 1.05723 4.16667 1.33337 4.16667H14.6667C14.9429 4.16667 15.1667 4.39053 15.1667 4.66667C15.1667 4.94281 14.9429 5.16667 14.6667 5.16667H1.33337C1.05723 5.16667 0.833374 4.94281 0.833374 4.66667Z"
        fill={props?.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6666 3.16667C14.9428 3.16667 15.1666 3.39053 15.1666 3.66667V7.66667C15.1666 7.94281 14.9428 8.16667 14.6666 8.16667C14.3905 8.16667 14.1666 7.94281 14.1666 7.66667V3.66667C14.1666 3.39053 14.3905 3.16667 14.6666 3.16667Z"
        fill={props?.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 7.33333C3.5 7.05719 3.72386 6.83333 4 6.83333H5.33333C5.60948 6.83333 5.83333 7.05719 5.83333 7.33333C5.83333 7.60947 5.60948 7.83333 5.33333 7.83333H4C3.72386 7.83333 3.5 7.60947 3.5 7.33333Z"
        fill={props?.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.83337 7.33333C6.83337 7.05719 7.05723 6.83333 7.33337 6.83333H8.66671C8.94285 6.83333 9.16671 7.05719 9.16671 7.33333C9.16671 7.60947 8.94285 7.83333 8.66671 7.83333H7.33337C7.05723 7.83333 6.83337 7.60947 6.83337 7.33333Z"
        fill={props?.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1666 7.33333C10.1666 7.05719 10.3905 6.83333 10.6666 6.83333H12C12.2761 6.83333 12.5 7.05719 12.5 7.33333C12.5 7.60947 12.2761 7.83333 12 7.83333H10.6666C10.3905 7.83333 10.1666 7.60947 10.1666 7.33333Z"
        fill={props?.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 9.66667C3.5 9.39053 3.72386 9.16667 4 9.16667H5.33333C5.60948 9.16667 5.83333 9.39053 5.83333 9.66667C5.83333 9.94281 5.60948 10.1667 5.33333 10.1667H4C3.72386 10.1667 3.5 9.94281 3.5 9.66667Z"
        fill={props?.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.83337 9.66667C6.83337 9.39053 7.05723 9.16667 7.33337 9.16667H8.66671C8.94285 9.16667 9.16671 9.39053 9.16671 9.66667C9.16671 9.94281 8.94285 10.1667 8.66671 10.1667H7.33337C7.05723 10.1667 6.83337 9.94281 6.83337 9.66667Z"
        fill={props?.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1666 9.66667C10.1666 9.39053 10.3905 9.16667 10.6666 9.16667H12C12.2761 9.16667 12.5 9.39053 12.5 9.66667C12.5 9.94281 12.2761 10.1667 12 10.1667H10.6666C10.3905 10.1667 10.1666 9.94281 10.1666 9.66667Z"
        fill={props?.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 12C3.5 11.7239 3.72386 11.5 4 11.5H5.33333C5.60948 11.5 5.83333 11.7239 5.83333 12C5.83333 12.2761 5.60948 12.5 5.33333 12.5H4C3.72386 12.5 3.5 12.2761 3.5 12Z"
        fill={props?.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.83337 12C6.83337 11.7239 7.05723 11.5 7.33337 11.5H8.66671C8.94285 11.5 9.16671 11.7239 9.16671 12C9.16671 12.2761 8.94285 12.5 8.66671 12.5H7.33337C7.05723 12.5 6.83337 12.2761 6.83337 12Z"
        fill={props?.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1666 12C10.1666 11.7239 10.3905 11.5 10.6666 11.5H12C12.2761 11.5 12.5 11.7239 12.5 12C12.5 12.2761 12.2761 12.5 12 12.5H10.6666C10.3905 12.5 10.1666 12.2761 10.1666 12Z"
        fill={props?.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.33337 3.16667C1.60952 3.16667 1.83337 3.39053 1.83337 3.66667V7.66667C1.83337 7.94281 1.60952 8.16667 1.33337 8.16667C1.05723 8.16667 0.833374 7.94281 0.833374 7.66667V3.66667C0.833374 3.39053 1.05723 3.16667 1.33337 3.16667Z"
        fill={props?.fill}
      />
    </SvgIcon>
  )
}

export default CalenderIcon
